<mat-icon>{{favorite ? 'star_rate': 'star_border'}}</mat-icon>
